module.exports = __webpack_public_path__ + "static/media/shweebee-rules-reduced-new-cropped.c17ba5b3.jpg";